export default __webpack_public_path__ + "static/media/Temperature.6ff43c27.gif";